import { ReactNode } from 'react';
import { DesktopDownloadIcon } from '@icons/DesktopDownloadIcon';
import { MobileDownloadIcon } from '@icons/MobileDownloadIcon';

import { PlainButton } from '../PlainButton/index';
import { DictionaryService, type DictionaryItem } from 'service/dictionary/dictionaryService';
import { Text as Paragraph, Title } from 'components/Typography';

export interface IstencilData {
  Id: string;
  Title: string;
  Url: string;
}

export const StencilDownload = ({
  stencilData,
  copy,
}: {
  stencilData: IstencilData[];
  copy: DictionaryItem[];
}): ReactNode => {
  const title = DictionaryService.getCopy('stencil_title', copy);
  const label = DictionaryService.getCopy('stencil_label', copy);
  const buttonLabel = DictionaryService.getCopy('stencil_download_button_label', copy);
  return (
    <div>
      {' '}
      <Title className="mb-4 md:mb-38" tag="div" type="md">
        {title}
      </Title>
      <Paragraph className="text-gray-500 mb-18 font-normal" tag="div" type="lead">
        {label}
      </Paragraph>
      <div className="mb-6 md:mb-10">
        <form action={stencilData?.[0].Url} target="_blank">
          <div className="xsPicture:block hidden">
            <PlainButton icon={<MobileDownloadIcon />} label={buttonLabel} buttonType="submit" />
          </div>
          <div className="xsPicture:hidden block">
            <PlainButton icon={<DesktopDownloadIcon />} label={buttonLabel} buttonType="submit" />
          </div>
        </form>
      </div>
    </div>
  );
};
